<template>
  <div>
    <v-container>
      <h1 class="primary--text font-weight-bold pb-4">
        {{
          isEditBlock
            ? $t("settings.blocks.updateBlock")
            : $t("settings.blocks.newBlock")
        }}
      </h1>
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <v-form
          :disabled="isEditBlock ? !currentAreaDetails.isActive : false"
          v-on:submit.prevent="handleSubmit(onSave)"
          :key="reRender"
        >
          <v-row align="center">
            <v-col cols="12" class="py-0 my-4">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                :name="$t('settings.area.title')"
              >
                <v-autocomplete
                  v-model="areaId"
                  :error-messages="errors"
                  :items="areaItems"
                  item-text="nameEn"
                  item-value="_id"
                  :search-input.sync="search"
                  :disabled="isEditBlock ? !currentAreaDetails.isActive : false"
                  outlined
                  dense
                  :label="$t('settings.area.title')"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.area.title") }}
                  </template>
                </v-autocomplete>
              </ValidationProvider>
            </v-col>
            <template
              align="center"
              v-for="(item, index) in blockModelObj.block"
            >
              <v-col
                cols="12"
                lg="5"
                sm="12"
                md="12"
                class="py-0 pt-6"
                :key="`${index}_nameEn`"
              >
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required"
                  :name="$t('settings.area.name') + $t('common.en')"
                >
                  <v-text-field
                    outlined
                    :error-messages="errors"
                    dense
                    :label="`${$t('settings.area.name')} (${$t('common.en')})`"
                    :disabled="isEditBlock ? !item.isActive : false"
                    color="secondary"
                    type="text"
                    v-model="item.nameEn"
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span
                      >{{ $t("settings.area.name") }} ({{ $t("common.en") }})
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col
                cols="12"
                lg="5"
                sm="12"
                md="12"
                class="py-0 pt-6"
                :key="`${index}_nameAr`"
              >
                <ValidationProvider
                  v-slot="{ errors }"
                  rules="required|arabicText"
                  :name="$t('settings.area.name') + $t('common.ar')"
                >
                  <v-text-field
                    outlined
                    :error-messages="errors"
                    :disabled="isEditBlock ? !item.isActive : false"
                    dense
                    :label="`${$t('settings.area.name')} (${$t('common.ar')})`"
                    color="secondary"
                    type="text"
                    v-model="item.nameAr"
                  >
                    <template #label>
                      <span class="red--text"><strong>* </strong></span
                      >{{ $t("settings.area.name") }} ({{ $t("common.ar") }})
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col
                v-if="isEditBlock"
                cols="12"
                lg="2"
                sm="5"
                md="5"
                class="py-0"
                :key="`${index}_id`"
              >
                <v-switch
                  v-model="item.isActive"
                  :label="item.isActive ? 'Active' : 'Disabled '"
                  @change="toggleBlockStatus(item)"
                ></v-switch>
              </v-col>
              <v-col
                v-else
                cols="12"
                lg="2"
                sm="5"
                md="5"
                class="py-0"
                :key="`${index}_id`"
              >
                <v-switch label="Active" input-value="true" readonly></v-switch>
              </v-col>
            </template>
            <v-col
              v-if="currentAreaDetails.isActive"
              class="mt-n6"
              cols="12"
              sm="12"
              md="12"
              align="right"
            >
              <v-btn
                depressed
                text
                color="primary"
                class="font-weight-bold text-none"
                x-small
                @click="addAnotherBlock"
              >
                <v-icon left small>mdi-plus</v-icon>
                {{ $t("settings.blocks.addAnotherblock") }}
              </v-btn>
            </v-col>
            <!-- <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('settings.area.nameEn')"
                  color="secondary"
                  type="text"
                  v-model="blockModelObj.nameEn"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="$t('settings.area.nameAr')"
                  color="secondary"
                  type="text"
                  v-model="blockModelObj.nameAr"
                >
                </v-text-field>
              </ValidationProvider>
            </v-col> -->
            <div class=" tw-flex tw-w-full tw-justify-end">
              <!-- <div class="d-flex justify-space-around"> -->
              <!-- <v-btn class="custom-button text-none" @click="onCancel">
                  {{ $t("common.cancel") }}
                </v-btn> -->
              <v-btn
                class="white--text rounded-lg"
                color="primary"
                width="20%"
                type="submit"
                :disabled="isEditBlock ? !currentAreaDetails.isActive : false"
                :loading="btnLoading"
              >
                {{
                  isEditBlock
                    ? currentAreaDetails.isActive
                      ? $t("common.update")
                      : $t("settings.area.disabled")
                    : $t("common.save")
                }}
              </v-btn>
              <!-- </div> -->
            </div>
            <v-col v-if="isError != null" cols="12" sm="12"
              ><Alert :message="isError" />
            </v-col>
          </v-row>
        </v-form>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
import "@/core/methods/validation_rules";
import { mapGetters } from "vuex";
import { toggleBlockStatus } from "../../methods/blocks/toggle_block_status";
import { createBlock } from "../../methods/blocks/create_block";
import { updateBlock } from "../../methods/blocks/update_block";
export default {
  data() {
    return {
      btnLoading: false,
      blockModelObj: {
        block: [
          {
            nameAr: "",
            nameEn: ""
          }
        ],
        area: null
      },
      areaId: null,
      areaItems: [],
      currentAreaDetails: {},
      search: "",
      isError: null,
      name: "",
      reRender: 0
    };
  },
  components: {
    Alert: () => import("@/core/components/Alert.vue")
  },
  mounted() {
    if (this.isEditBlock) {
      const editBlockData = this.$format.cloneVariable(this.editBlock);
      this.blockModelObj = {
        block: editBlockData.blocks
      };
      this.areaId = editBlockData.area._id;
      this.currentAreaDetails = editBlockData.area;
    }
  },
  watch: {
    isEditBlock: {
      handler() {
        if (this.isEditBlock) {
          let editBlockData = this.$format.cloneVariable(this.editBlock.blocks);
          this.blockModelObj = {
            block: []
          };
          editBlockData.forEach(each => {
            const eachBlock = {
              _id: each._id,
              nameEn: each.nameEn,
              nameAr: each.nameAr,
              isActive: each.isActive
            };
            this.blockModelObj.block.push(eachBlock);
          });
          this.areaId = this.editBlock._id;
          this.currentAreaDetails = this.editBlock.area;
        } else {
          this.blockModelObj = {
            block: [
              {
                nameAr: "",
                nameEn: ""
              }
            ]
          };
          this.areaId = null;
          this.reRender++;
        }
      },
      deep: true
    },
    search(val) {
      this.$apollo
        .query({
          query: require("@/settings/api/queries/area/area_query.graphql"),
          variables: {
            input: {
              limit: 0,
              skip: 0
            },
            filter: {
              searchKey: val
            }
          }
        })
        .then(data => {
          if (data.data.getAreas.areas)
            this.areaItems = data.data.getAreas.areas;
        });
    }
  },
  computed: {
    ...mapGetters(["isEditBlock", "editBlock"])
  },
  methods: {
    addAnotherBlock() {
      this.blockModelObj.block.push({ nameEn: "", nameAr: "" });
    },
    toggleBlockStatus(item) {
      toggleBlockStatus({
        id: item._id,
        status: item.isActive
      }).then(({ data }) => {
        if (data.toggleBlockStatus) {
          this.$root.$emit("snackbar", {
            snackbar: true,
            text: "Block Status Changed Successfully",
            color: "green"
          });
          this.$root.$emit("refetchBlock");
        }
      });
    },
    async onSave() {
      this.btnLoading = true;
      const inputObj = this.$format.cloneVariable(this.blockModelObj);
      const input = {
        input: {
          areaId:
            typeof this.areaId === "string" ? this.areaId : this.areaId._id,
          block: inputObj.block
        }
      };
      if (!this.isEditBlock) {
        createBlock(input).then(response => {
          if (response.data) {
            this.$root.$emit("refetchBlock");
            this.btnLoading = false;
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.saveSuccess"),
              color: "green"
            });
            this.blockModelObj = {
              block: [
                {
                  nameAr: "",
                  nameEn: ""
                }
              ]
            };
            this.areaId = null;
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
          }
        });
      } else {
        const updateInput = {
          id: input.input.areaId,
          input: {
            areaId: input.input.areaId,
            block: input.input.block.map(val => {
              return {
                blockId: val._id,
                nameEn: val.nameEn,
                nameAr: val.nameAr
              };
            })
          }
        };
        updateBlock(updateInput).then(response => {
          if (response.data) {
            this.btnLoading = false;
            this.$root.$emit("refetchBlock");
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$store.commit("IS_EDIT_BLOCK", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.updateSuccess"),
              color: "green"
            });
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
            setTimeout(() => {
              this.isError = null;
            }, 5000);
          }
        });
      }
    }
    // onCancel() {
    //   this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
    //   this.$store.commit("IS_EDIT_BLOCK", false);
    // },
  }
};
</script>
